import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type FilterParameter } from '../services/getAllRegularKekFilterParameters'

export interface RegularKekParameter {
  use: number[]
}

export interface getAllRegularKekParameterState {
  isLoading: boolean
  data: FilterParameter | null
  error: string | null
  httpStatus: number | null
}

const initialState: getAllRegularKekParameterState = {
  isLoading: false,
  data: null,
  error: null,
  httpStatus: 0
}

export const getAllRegularKekParameterSlice = createSlice({
  name: 'RegularKekFilterParameter',
  initialState,
  reducers: {
    getAllRegularKekParameterDataLoading: (state): getAllRegularKekParameterState => {
      return {
        isLoading: true,
        data: null,
        error: null,
        httpStatus: 0
      }
    },
    getAllRegularKekParameterDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): getAllRegularKekParameterState => {
      return {
        isLoading: false,
        data: null,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    getAllRegularKekParameterData: (state, action: PayloadAction<any>): getAllRegularKekParameterState => {
      return {
        isLoading: false,
        data: action.payload.data,
        error: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { getAllRegularKekParameterDataLoading, getAllRegularKekParameterDataError, getAllRegularKekParameterData } = getAllRegularKekParameterSlice.actions
export default getAllRegularKekParameterSlice.reducer
